import * as React from 'react';

import { AboutRealtorDesktop } from '../../components/AboutRealtorDesktop/AboutRealtorDesktop';
import { getRieltorDescription } from '../../components/AboutRealtorDesktop/helpers';
import { ISpecialistCatalogListingSchema } from '../../repositories/demand/entities/specialist_catalog/SpecialistCatalogListingSchema';
import { getDescriptionText, isLongDescription } from '../../utils/description';
import { getCounters } from '../../utils/counters';
import { getRatingSubtitle } from '../../utils/subtitle';
import { IGetAgentInfoResponseV3Schema } from '../../../node/repositories/agent-card/entities/agent_info/GetAgentInfoResponseV3Schema';

export interface IAboutRealtorDesktopContainerProps {
  realtorCardData: IGetAgentInfoResponseV3Schema;
  realtor: ISpecialistCatalogListingSchema;
}

export function AboutRealtorDesktopContainer(props: IAboutRealtorDesktopContainerProps) {
  const { realtorCardData, realtor } = props;
  const { reviewsRate, reviewsCount } = realtor;
  const {
    agent: { age, name, avatarUrl, companyName, regionsNames, description, experience, skills, moderationInfo },
    offers,
  } = realtorCardData;

  const [descriptionMinimized, setdescriptionMinimized] = React.useState(isLongDescription(description));
  const descriptionText = getDescriptionText(description, descriptionMinimized);
  const counters = getCounters({ experience, age, offers });
  const ratingSubtitle = getRatingSubtitle({ reviewsRate, reviewsCount });

  const handleDescriptionClick = React.useCallback(() => {
    setdescriptionMinimized(false);
  }, []);

  const about = getRieltorDescription({
    descriptionText,
    skills,
    regionsNames,
    companyName,
    onDescriptionOpen: descriptionMinimized ? handleDescriptionClick : undefined,
  });

  return (
    <AboutRealtorDesktop
      about={about}
      avatarUrl={avatarUrl}
      counters={counters}
      isAvatarRound={true}
      name={name}
      onDescriptionClick={handleDescriptionClick}
      ratingSubtitle={ratingSubtitle}
      rate={Number(reviewsRate) || 0}
      moderationInfo={moderationInfo || undefined}
    />
  );
}
